// Two columns, both read-only: the screen no longer edits, and the API has no
// route that would accept it. The `editable: 'never'` and the multiline
// editComponent that used to be here were the machinery for an Add dialog that
// is gone.
//
// ⚠️ `field` is `code`, not `description`. The column pointed at a field the
// rename had removed, and the screen drew an empty column for a day without
// the API, the sweeps or the write exercise noticing - all three were right,
// and only the browser walk could see it.
export default [
  {
    title: 'ID',
    field: 'id',
    width: 200,
  },
  {
    title: 'Descrição',
    field: 'code',
    width: 400,
  }
];
